/**
 * Ensure a value is within a minimum and maximum range
 * @param value
 * @param scale
 * @returns
 */
export function restrictValueToScale(value: number, scale: number[]) {
  return Math.max(
    /**
     * Compare the provided value against the biggest value in the scale, and choose the smallest one of the two
     * Cases:
     * 1. If `value` exceeds the scale, use the largest number in the scale.
     * 2. Use `value`
     */
    Math.min(value, Math.max(...scale)),
    /**
     * Get the smallest value in the scale
     * The value from the previous step is guaranteed to be at or less than the upper limit of the scale.
     * 
     * Cases:
     * 1. If the value in the previous step is smaller than the scale, use the smallest value in the scale.
     * 2. Use `value`
     */
    Math.min(...scale)
  );
}

/**
 * 
 * @param value The value to restrict
 * @param left Left bound of the number. This is not guaranteed to be less than `right`
 * @param right Right bound of the number. This is not guaranteed to be greater than `left`
 * @returns Restricts `value` to be between `left` and `right`. If `value` exceeds the range then the upper or lower bound of the range will be returned
 */
export function restrictValueToRange(value: number, left: number, right: number) {
  const max = Math.max(left, right)
  const min = Math.min(left, right)
  return Math.max(Math.min(value, max), min)
}
